import { combineReducers } from 'redux';

import abacus from './modules/abacus';
import content from './modules/content';
import intl from './modules/intl';
import recentActivity from './modules/recentActivity';
import renderOptions from './modules/renderOptions';
import scratchpad from './modules/scratchpad';
import system from './modules/system';
import user from './modules/user';
import login from './modules/login';
import propertyTypeImages from './modules/propertyTypeImages';

export default combineReducers({
  abacus,
  content,
  intl,
  recentActivity,
  renderOptions,
  scratchpad,
  system,
  user,
  login,
  propertyTypeImages
});
